import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../Assets/InsuranceExchange_logo.svg';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
const Header = () => {
  return (
    <div >
      <nav class="navbar navbar-expand-lg border-bottom shadow-sm" style={{ backgroundColor: "#ffffff" }}>
        <div class="container-fluid">
          <Navbar.Brand as={Link} to="/"><img src={logo} alt='Employment Exchange' className='img-fluid logo' style={{ width: 320 }} /></Navbar.Brand>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>

    </div>
  )
}

export default Header
